/* Stylesheet */

.pagination {
  display: flex;
  align-items: center;
  gap: 12px;

  .fab_button {
    height: 28px;
    width: 28px;
    --background: transparent;
    --box-shadow: none;

    .icon {
      height: 16px;
      width: 16px;
      color: var(--ion-color-dark-primary);
    }
  }

  .current_page {
    font-size: 0.875rem;
    color: var(--ion-color-dark-primary);
  }
}
